// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-md":"768px","button":"ScrollUp_button__z8k7r","arrow":"ScrollUp_arrow__l2G10","scroll-up":"ScrollUp_scroll-up__2FWTr"};